import React from 'react'
import { ReactComponent as ResetIcon } from './icons/reset.svg'
import { captureEvent } from '../../../../analytics'
import { analyticsEvents } from '../../../../analytics/events'
import use3DViewer from '../../../../hooks/use3DViewer'
function Reset3DViewer({ className = '' }) {

  const { send } = use3DViewer(null, '3d-viewer')
  return (
    <button
      onClick={() => {
        captureEvent(analyticsEvents.RESET_TAPPED)
        send('reset-view')
      }}
      type="button"
      className={`h-[32px] w-[32px] bg-[#fff] rounded-[4px] flex items-center justify-center shadow-md relative ${className}`}
    >
      <ResetIcon />
    </button>
  )
}

export default Reset3DViewer
